import { render, staticRenderFns } from "./kllk-footer-nav.vue?vue&type=template&id=b3f1dc86&scoped=true"
import script from "./kllk-footer-nav.vue?vue&type=script&lang=js"
export * from "./kllk-footer-nav.vue?vue&type=script&lang=js"
import style0 from "./kllk-footer-nav.vue?vue&type=style&index=0&id=b3f1dc86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f1dc86",
  null
  
)

export default component.exports